import { LanguagesAPIPromiseClient } from "../../../gen/witbooking/backoffice/languages/v1/languages_api_grpc_web_pb";
import {
  GetLanguageRequest,
  GetLanguagesRequest,
  Language,
  UpdateLanguageRequest,
} from "../../../gen/witbooking/backoffice/languages/v1/languages_api_pb";
import { addAuthzMetadataGrpcCall, buildGrpcClient } from "../../../lib/grpc";
import { LanguageEntity } from "../domain/languages.entity";

const grpcClient: LanguagesAPIPromiseClient = buildGrpcClient(LanguagesAPIPromiseClient);

function dtoFromEntity(obj: LanguageEntity): Language {
  const result = new Language();
  result.setId(obj.id);
  result.setName(obj.name);
  result.setCode(obj.code);
  result.setPrimary(obj.primary);
  result.setActive(obj.active);
  result.setVisible(obj.visible);
  return result;
}

export async function getAllEntities(): Promise<LanguageEntity[]> {
  const request = new GetLanguagesRequest();
  const getAllLanguages = addAuthzMetadataGrpcCall(grpcClient, grpcClient.getAllLanguages);
  const response = await getAllLanguages(request);
  return response.getLanguagesList().map(m => m.toObject());
}

export async function getEntity(id: string): Promise<LanguageEntity> {
  const request = new GetLanguageRequest();
  request.setId(id);
  const getLanguage = addAuthzMetadataGrpcCall(grpcClient, grpcClient.getLanguage);
  const response = await getLanguage(request);
  const entity = response.getLanguage();
  if (!entity) {
    throw new Error("Unexpected reply obtaining language");
  }
  return entity.toObject();
}

export async function updateEntity(entity: LanguageEntity): Promise<void> {
  const request = new UpdateLanguageRequest();
  request.setLanguage(dtoFromEntity(entity));
  const updateLanguage = addAuthzMetadataGrpcCall(grpcClient, grpcClient.updateLanguage);
  await updateLanguage(request);
}
